import { TestId } from "../testIdType"

export const testId: TestId = {
    articleComments: "article-comments",
    articleCommentsView: "article-comments-view",
    enableArticleCommentsInputMode: "enable-article-comments-input-mode",
    threadOpenButton: "thread-open-button"
}
